import keyMirror from 'keymirror';
export default keyMirror({
  MFA_SAVE_SUCCESS: null,
  MFA_SAVE_FAIL: null,
  MFA_DESTROY_SUCCESS: null,
  MFA_DESTROY_FAIL: null,
  MFA_CHANGE_PIN: null,
  MFA_LOAD_SECRET: null,
  MFA_CLEAR_ERROR: null,
  // Interaction constants
  MFA_LOGIN_SAVE: null,
  MFA_LOGIN_CLEAR: null,
  // Modal constants
  MFA_MODAL_TOGGLE: null
});